export default __webpack_public_path__ + "static/media/congratsHealthgenom.f42da4da.svg";